import { isEmpty, isNil, isUndefined } from "lodash";
import { checkContactNumber, checkDOB, checkEmail, checkNRIC } from "../../form-helper";


export class SharedValidators {

  static Basic = (value: any, message:string="This is a required field.") => {
    if (isNil(value)) {
      return { isValid: false };
    } else if (value === "") {
      return { isValid: false, message: message };
    } else {
      return { isValid: true };
    }
  }
  static BasicIsNil = (value: any) => {
    if (isNil(value)) {
      return { isValid: false };
    } else {
      return { isValid: true };
    }
  }
 
  static BasicEmpty = (value: any) => {
    if (isNil(value)) {
      return { isValid: false };
    } else if (isEmpty(value)) {
      return { isValid: false, message: "This is a required field." };
    } else {
      return { isValid: true };
    }
  }

  static BasicUndefined = (value: any) => {
    if (isNil(value)) {
      return { isValid: false };
    } else if (isUndefined(value)) {
      return { isValid: false, message: "This is a required field." };
    } else {
      return { isValid: true };
    }
  }


  static BasicEmptyUndefined = (value: any) => {
    if (isNil(value)) {
      return { isValid: false };
    } else if (isEmpty(value) || value === undefined ) {
      return { isValid: false, message: "This is a required field." };
    } else {
      return { isValid: true };
    }
  }
 
  static BasicBoolean = (value: any) => {
    //Can add params for dynamic checking
    if (isNil(value)) {
      return { isValid: false };
    } else if (value === false ) {
      return { isValid: false, message: "This is a required field." };
    } else {
      return { isValid: true };
    }
  }


  static Email = (value: any) => {
    if (isNil(value)) {
      return { isValid: false };
    } else if (isEmpty(value)) {
      return { isValid: false, message: "This is a required field." };
    } else if (!checkEmail(value)) {
      return { isValid: false, message: "Please enter a valid email address." };
    } else {
      return { isValid: true };
    }

  }

  static Mobile = (value: any) => {

    if (isNil(value)) {
      return { isValid: false };
    } else if (isEmpty(value)) {
      return { isValid: false, message: "This is a required field." };
    } else if (value === "") {
      return { isValid: false, message: "This is a required field." };
    } else if (!checkContactNumber(value)) {
      return { isValid: false, message: "A valid Singapore contact number should be only 8 digits." };
    } else {
      return { isValid: true };
    }
  }

  static Uinfin = (value: any) => {
    if (isNil(value)) {
      return { isValid: false };
    } else if (value === "") {
      return { isValid: false, message: "This is a required field." };
    } else if (!checkNRIC(value)) {
      return { isValid: false, message: "The format for NRIC input is invalid. Please enter the correct NRIC." };
    } else {
      return { isValid: true };
    }
  }

  static MalaysianId = (value: any) => {
    if (isNil(value)) {
      return { isValid: false };
    } else if (value === "") {
      return { isValid: false, message: "This is a required field." };
    } else if (/\D/.test(value) || value.length != 12) {
      return { isValid: false, message: "Wrong Malaysian ID format" };
    } else {
      return { isValid: true };
    }
  }

  static OtherId = (value: any, characterLength: number = 20) => {
    if (isNil(value)) {
      return { isValid: false };
    } else if (value === "") {
      return { isValid: false, message: "This is a required field." };
    } else if (/[^a-zA-Z0-9]/.test(value)) {
      return { isValid: false, message: "Wrong ID format" };
    } else if (value.length > characterLength) {
      return { isValid: false, message: `Maximum length of the ID entered should be ${characterLength}` };
    } else {
      return { isValid: true };
    }
  }

  static Dob = (value: any) => {
    if (isNil(value)) {
      return { isValid: false };
    } else if (value === "") {
      return { isValid: false, message: "This is a required field." };
    } else if (!checkDOB(value, 21)) {
      return { isValid: false, message: "The proposed owner must be at least 21 years old." };
    } else {
      return { isValid: true };
    }

  }

  static GrossDomesticIncome = (value: any) => {
    if (isNil(value)) {
      return { isValid: false };
    } else if (value === "") {
      return { isValid: false, message: "This is a required field." };
    } else if (!checkDOB(value, 21)) {
      return { isValid: false, message: "The proposed owner must be at least 21 years old." };
    } else {
      return { isValid: true };
    }

  }
  
  static ResidentialStatus = (value: any) => {
    if (isNil(value)) {
      return { isValid: false };
    } else if (value === "") {
      return { isValid: false, message: "This is a required field." };
    } else if (!checkDOB(value, 21)) {
      return { isValid: false, message: "The proposed owner must be at least 21 years old." };
    } else {
      return { isValid: true };
    }

  }
  static SprObtainedDate = (value: any, enforceSPR:boolean = true) => {
    if(!value) {
      return { isValid: false, message: "This is a required field." };
    } 
    else if(!checkDOB(value, 3) && enforceSPR){
      return { isValid: false, message: "SPR cannot obtained less than 3 year" };
    }
    else{
      return { isValid: true };
    }
  }

}